export const defaultSegmentServiceCompany = "BS";
export const defaultSegmentServiceHousehold = "HZ";
